module.exports = __webpack_public_path__ + "img/151.aaf79970.jpg";